import { render, staticRenderFns } from "./merchantAdvertising.vue?vue&type=template&id=3b72c93a&scoped=true"
import script from "./merchantAdvertising.vue?vue&type=script&lang=js"
export * from "./merchantAdvertising.vue?vue&type=script&lang=js"
import style0 from "./merchantAdvertising.vue?vue&type=style&index=0&id=3b72c93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b72c93a",
  null
  
)

export default component.exports